import { APPLICATION_SUBPATH } from '@/config/global'

const BAYER_CLIENT_ID = '773a7670-64ca-4869-be37-9c75ad240feb'
export const IS_BAYER_APP = window.ENV.APP_MODE.toLowerCase() === 'bayer-app'

export const IS_BAYER =
  import.meta.env.VITE_MSAL_CLIENT_ID === BAYER_CLIENT_ID ||
  window.ENV.MSAL_CLIENT_ID === BAYER_CLIENT_ID ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('bayer')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('azure.cnb')) ||
  window.origin.includes('azure.cnb') ||
  IS_BAYER_APP

export const IS_BASF =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('basf')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('basf')) ||
  window.origin.includes('coatings')

export const IS_SAIFTY_CLOUD =
  import.meta.env.VITE_AUTH0_DOMAIN?.includes('saifty.cloud') || window.ENV.AUTH0_DOMAIN?.includes('saifty.cloud')

export const IS_BYK =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('byk')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('byk'))

export const IS_HERAEUS =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL &&
    import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('heraeus')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('heraeus'))

export const IS_LANXESS =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('lnx')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('lnx')) ||
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL &&
    import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('lanxess')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('lanxess'))

export const IS_HENKEL =
  (import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL && import.meta.env.VITE_API_SAIFTY_APIS_BASE_URL.includes('henkel')) ||
  (window.ENV.API_MONOLITH_BASE_URL && window.ENV.API_MONOLITH_BASE_URL.includes('henkel'))

export const IS_SAIFTY = window.ENV.APP_MODE === 'saifty'
export const IS_MICROBRAINS = window.ENV.APP_MODE === 'microbrains'
export const IS_INDUSTRIAL_IDENTITIES = window.ENV.APP_MODE === 'industrial-identities'

export let APP_ICON = '/img/sidebar/logo.svg'
export let APP_LOGO = '/logo.svg'
if (IS_MICROBRAINS) {
  APP_ICON = '/microbrains/icon.png'
  APP_LOGO = '/microbrains/logo.png'
}
if (IS_INDUSTRIAL_IDENTITIES) {
  APP_ICON = '/industrial-identities/icon.png'
  APP_LOGO = '/industrial-identities/logo.png'
}

if (IS_BAYER_APP) {
  APP_ICON = `${APPLICATION_SUBPATH || '/'}${APP_ICON}`
  APP_LOGO = `${APPLICATION_SUBPATH || '/'}logo.svg`
}

export const APP_LOGO_WITH_CONFIG = getLogoConfig()

const commonRestrictedRoutes = ['query-builder', 'query-builder-id', 'ai-chat']

export function restrictedRoutesByCustomer() {
  let routesToRestrict: string[] = []

  // Add routes based on environment variables
  if (!window.ENV.AI_CHAT_ENABLED && !IS_MICROBRAINS) {
    routesToRestrict.push('ai-chat')
  }
  if (!window.ENV.QUERY_BUILDER_ENABLED || IS_MICROBRAINS) {
    routesToRestrict.push('query-builder', 'query-builder-id')
  }
  if (!window.ENV.ASSESSMENTS_PAGE_ENABLED || IS_MICROBRAINS) {
    routesToRestrict.push('assessment')
  }
  if (!window.ENV.REQUESTS_PAGE_ENABLED && !IS_MICROBRAINS && !IS_INDUSTRIAL_IDENTITIES) {
    routesToRestrict.push('requests', 'requests-new', 'requests-id')
  }
  if (
    (!window.ENV.DATA_SPACE_ENABLED && !window.ENV.SAP_MAPPING_ENABLED) ||
    IS_MICROBRAINS ||
    IS_INDUSTRIAL_IDENTITIES
  ) {
    routesToRestrict.push('mappings', 'mappings-id')
  }
  if (
    !(import.meta.env.VITE_API_SAP_SYNC_CONFIG_BASE_URL || window.ENV.API_SAP_SYNC_CONFIG_BASE_URL) ||
    IS_MICROBRAINS ||
    IS_INDUSTRIAL_IDENTITIES
  ) {
    routesToRestrict.push('sync-configuration')
  }
  if (!window.ENV.WORKFLOWS_ENABLED && !IS_MICROBRAINS) {
    routesToRestrict.push('workflows', 'workflows-id')
  }

  if (IS_MICROBRAINS || IS_INDUSTRIAL_IDENTITIES) {
    routesToRestrict.push('data-lookup', 'library')
  }

  if (!window.ENV.DATASPACE_TO_DATAOBJECT_PAGE_ENABLED && !IS_INDUSTRIAL_IDENTITIES) {
    routesToRestrict.push('dataspace-to-dataobject')
  }

  // Add customer-specific restrictions
  if (IS_BASF || IS_SAIFTY_CLOUD || IS_LANXESS) {
    routesToRestrict = [...new Set([...routesToRestrict, ...commonRestrictedRoutes])]
  }

  if (!window.ENV.BACKLOG_PAGE_ENABLED) {
    routesToRestrict.push('backlog')
  }

  return routesToRestrict
}

function getLogoConfig() {
  if (IS_MICROBRAINS) {
    return {
      logo: '/microbrains/icon.png',
      logoType: '/microbrains/logotype.png',
      width: '3.5rem',
      smallWidth: '2.5rem',
    }
  }

  if (IS_INDUSTRIAL_IDENTITIES) {
    return {
      logo: '/industrial-identities/icon.png',
      logoType: '/industrial-identities/logotype.png',
      width: '5rem',
      smallWidth: '3.5rem',
    }
  }

  if (IS_BAYER) {
    return {
      logo: APP_LOGO,
      width: '5rem',
      smallWidth: '3.5rem',
    }
  }

  return { logo: '/logo.svg' }
}

export const BASF_COATINGS_BUSINESS_UNIT_ZCQ_100 = 'ZCQ-100'
export const BASF_COATINGS_BUSINESS_UNIT_ZCQ_300 = 'ZCQ-300'

export const BASF_COATINGS_BUSINESS_UNITS = [BASF_COATINGS_BUSINESS_UNIT_ZCQ_100, BASF_COATINGS_BUSINESS_UNIT_ZCQ_300]
